export class UrlInfo {
  urlCode: string;
  url: string;

  update(source: UrlInfo) {
    this.urlCode = source.urlCode;
    this.url = source.url;
  }
}
